import { Lightning } from '@lightningjs/sdk'
import { getColor, grey50 } from '../../constants/colors'
import { getText } from '../../utils/dictionary'
import Button from '../button/button'
import { Loader } from '../Loader/LoaderWrapper'

export class PaginationErrorMessage extends Lightning.Component {
  private _retryAction: () => void
  private _isPreviousPageError = false

  static _template() {
    return {
      w: (w) => w,
      h: 120,
      Container: {
        w: (w) => w,
        h: (h) => h,
        flex: {
          direction: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        },
        Info: {
          text: {
            text: getText('genericErrorText'),
            textColor: getColor(grey50),
            fontSize: 32,
          },
        },
        Button: {
          w: 334,
          type: Button,
          label: getText('reload'),
          flexItem: { marginTop: 24 },
        },
      },
      Loader: {
        width: 52,
        height: 52,
        x: (w) => w / 2,
        y: (h) => h / 2,
        mount: 0.5,
        type: Loader,
        visible: false,
      },
    }
  }

  get container() {
    return this.tag('Container')
  }

  get loader() {
    return this.tag('Loader')
  }

  get button() {
    return this.tag('Button')
  }

  set retryAction(v) {
    this._retryAction = v
  }

  set isPreviousPageError(v: boolean) {
    this._isPreviousPageError = v ?? false
  }

  get isPreviousPageError() {
    return this._isPreviousPageError
  }

  _getFocused() {
    return this.button
  }

  _handleEnter() {
    this.container.visible = false
    this.loader.visible = true
    this?._retryAction()
  }
}
